import { render, staticRenderFns } from "./StatisticsMarketingDelivrability.vue?vue&type=template&id=28e2b314&"
import script from "./StatisticsMarketingDelivrability.vue?vue&type=script&lang=js&"
export * from "./StatisticsMarketingDelivrability.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMarketingDelivrability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VCard,VCardText,VCol,VRow,VSwitch})
